import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormArray, FormControl } from "@angular/forms";
import { addDays } from "date-fns";
import { RecurrencePattern } from "../../../shared/services/request.service";

@Component({
  selector: "app-recurrence",
  templateUrl: "./recurrence.component.html"
})
export class RecurrenceComponent implements OnInit {
  @Input()
  experimentDesignFormGroup: FormGroup;

  @Input()
  plantingDate: Date;

  recurrenceNone: number;
  recurrenceWeekly: number;

  public dayNames: Array<string> = ["M", "T", "W", "R", "F"];

  public get recurrenceWeekInterval(): FormControl {
    return <FormControl>this.experimentDesignFormGroup.get("recurrenceWeekInterval");
  }

  public get recurrenceDays(): FormArray {
    return <FormArray>this.experimentDesignFormGroup.get("recurrenceDays");
  }

  public get recurrencePattern(): FormControl {
    return <FormControl>this.experimentDesignFormGroup.get("recurrencePattern");
  }

  public get recurrenceEndDate(): FormControl {
    return <FormControl>this.experimentDesignFormGroup.get("recurrenceEndDate");
  }

  public get minEndDate(): Date {
    return addDays(this.plantingDate, 1);
  }

  public get maxEndDate(): Date {
    return addDays(this.plantingDate, 30);
  }

  ngOnInit(): void {
    this.recurrenceNone = RecurrencePattern.None;
    this.recurrenceWeekly = RecurrencePattern.Weekly;
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/recurrence/recurrence.component.ts